"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
require("es6-shim");
require("whatwg-fetch");
var classNames = require("classnames");
var React = require("react");
var ReactDOM = require("react-dom");
var AllPermissions_1 = require("../shared/model/AllPermissions");
var utilities_1 = require("../shared/utilities");
var Notifications = require("./NotificationMessageNotifier");
var NotificationMessageNotifier = Notifications.NotificationMessageNotifier;
var App = (function (_super) {
    __extends(App, _super);
    function App(props) {
        var _this = _super.call(this, props) || this;
        _this.base = "";
        _this.currentAgentGroupEnvironment = {};
        _this.generateHref = function (link) {
            if (!link.overwriteCurrentEnvironmentInUrl) {
                return _this.base + link.href;
            }
            var environment = _this.getEnvironmentFromUrl();
            return _this.base + link.href + environment.environmentName + (link.useAgentGroups ? environment.agentGroupName : "");
        };
        _this.state = {
            activeLink: "",
            hasRightsFor: {}
        };
        _this.tick = _this.tick.bind(_this);
        setInterval(_this.tick, 500);
        return _this;
    }
    App.prototype.componentDidMount = function () {
        try {
            this.setState({ hasRightsFor: utilities_1.Utilities.getAllUserPermissions() });
        }
        catch (exception) {
            console.error("Unable to retrive user permissions: " + exception);
            throw exception;
        }
        this.updateState();
    };
    App.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement("ul", { className: "nav navbar-nav" }, navigationBarData.map(function (link) {
                return _this.state.hasRightsFor[link.permission] ?
                    link.children != null ?
                        React.createElement("li", { key: link.activeLinkName, className: classNames("dropdown", { active: (link.children.some(function (x) { return x.activeLinkName === _this.state.activeLink; })) }) },
                            React.createElement("a", { href: "#", className: "dropdown-toggle", "data-toggle": "dropdown", role: "button", "aria-haspopup": "true", "aria-expanded": "false" },
                                link.label,
                                " ",
                                React.createElement("span", { className: "caret" })),
                            React.createElement("ul", { className: "dropdown-menu" }, link.children.map(function (childLink) {
                                return _this.state.hasRightsFor[childLink.permission] ?
                                    React.createElement("li", { key: childLink.activeLinkName, className: classNames("dropdown-menu-item menu-item-reversed-padding", { selected: (_this.state.activeLink === childLink.activeLinkName) }) },
                                        React.createElement("a", { href: _this.generateHref(childLink) }, childLink.label))
                                    : null;
                            })))
                        : React.createElement("li", { key: link.activeLinkName, className: classNames({ active: (_this.state.activeLink === link.activeLinkName) }) },
                            React.createElement("a", { href: _this.generateHref(link) }, link.label))
                    : null;
            })),
            React.createElement(NotificationMessageNotifier, null)));
    };
    App.prototype.tick = function () {
        var env = this.getEnvironmentFromUrl();
        if (!_.isEqual(env, this.currentAgentGroupEnvironment)) {
            this.updateState();
        }
    };
    App.prototype.updateState = function () {
        this.base = document.getElementsByTagName("base")[0].href;
        this.currentAgentGroupEnvironment = this.getEnvironmentFromUrl();
        var urlParts = this.getUriPartsWithoutBase();
        var controller = urlParts[0];
        this.setState({ activeLink: controller });
    };
    App.prototype.getUriPartsWithoutBase = function () {
        var urlPart = window.location.href;
        var basePart = this.base;
        var urlPartWithoutBase = urlPart.replace(basePart, "").split("/");
        return urlPartWithoutBase;
    };
    App.prototype.getEnvironmentFromUrl = function () {
        var urlParts = this.getUriPartsWithoutBase();
        var environmentPart = "";
        var agentGroupPart = "";
        switch (this.state.activeLink) {
            case "Process":
            case "SubProcess":
                if ((urlParts[1] === "List") && urlParts.length >= 3) {
                    environmentPart = "/" + urlParts[2];
                    agentGroupPart = urlParts.length >= 4 ? "/" + urlParts[3] : "";
                }
                break;
            case "EnvironmentVariables":
            case "MonitoringRules":
                if (urlParts.length >= 3) {
                    environmentPart = "/" + urlParts[2];
                }
                break;
            case "Environment":
            case "ApiManagement":
                if (urlParts.length >= 2) {
                    environmentPart = "/" + urlParts[1];
                    agentGroupPart = urlParts.length >= 3 ? "/" + urlParts[2] : "";
                }
                break;
            default:
                environmentPart = "";
        }
        return { agentGroupName: agentGroupPart, environmentName: environmentPart };
    };
    return App;
}(React.Component));
var navigationBarData = [
    { href: "ApiManagement", activeLinkName: "ApiManagement", label: FRENDS.Localizations.ApiManagement, permission: AllPermissions_1.Permissions.ApiManagementView, overwriteCurrentEnvironmentInUrl: true, useAgentGroups: true },
    { href: "Process/List", activeLinkName: "Process", label: FRENDS.Localizations.Processes, permission: AllPermissions_1.Permissions.ProcessView, overwriteCurrentEnvironmentInUrl: true, useAgentGroups: true },
    { href: "SubProcess/List", activeLinkName: "SubProcess", label: FRENDS.Localizations.Subprocesses, permission: AllPermissions_1.Permissions.SubProcessEdit, overwriteCurrentEnvironmentInUrl: true, useAgentGroups: true },
    { href: "EnvironmentVariables/List", activeLinkName: "EnvironmentVariables", label: FRENDS.Localizations.EnvironmentVariables, permission: AllPermissions_1.Permissions.EnvironmentVariablesEdit, overwriteCurrentEnvironmentInUrl: true },
    {
        href: "", activeLinkName: "Administration", label: FRENDS.Localizations.Administration, permission: AllPermissions_1.Permissions.AdministrationView, overwriteCurrentEnvironmentInUrl: false,
        children: [
            { href: "Environment", activeLinkName: "Environment", label: FRENDS.Localizations.Environments, permission: AllPermissions_1.Permissions.EnvironmentEdit, overwriteCurrentEnvironmentInUrl: true, useAgentGroups: true },
            { href: "Task", activeLinkName: "Task", label: FRENDS.Localizations.Tasks, permission: AllPermissions_1.Permissions.TaskView, overwriteCurrentEnvironmentInUrl: false },
            { href: "MonitoringRules/List", activeLinkName: "MonitoringRules", label: FRENDS.Localizations.MonitoringRules, permission: AllPermissions_1.Permissions.MonitoringRulesView, overwriteCurrentEnvironmentInUrl: true },
            { href: "UserManagement", activeLinkName: "UserManagement", label: FRENDS.Localizations.UserManagement_Users, permission: AllPermissions_1.Permissions.UserManagementAdmin, overwriteCurrentEnvironmentInUrl: false },
            { href: "ApiKeyManagement", activeLinkName: "ApiKeyManagement", label: FRENDS.Localizations.Administration_ApiKeys, permission: AllPermissions_1.Permissions.ApiKeyManagementAdmin, overwriteCurrentEnvironmentInUrl: false }
        ]
    }
];
var navigationContainer = document.getElementById("menu");
if (navigationContainer) {
    var render = function (Component) { return ReactDOM.render((React.createElement(Component, null)), navigationContainer); };
    render(App);
}



//////////////////
// WEBPACK FOOTER
// ./Scripts/app/navigation/App.tsx
// module id = 1818
// module chunks = 6